<div class="card shadow">
  <div class="card-header d-flex align-items-center">
    <div class="mr-auto font-weight-bold">
      <i class="fas fa-envelope fa-fw mr-2"></i>
      Email Addresses
    </div>
    <div>
      <ng-template #emailContent let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">
            {{ formGroup.value.id ? 'Update' : 'Add' }} Email
          </h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="closeModal(formGroup, modal)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formGroup">
            <div class="form-group">
              <label>Email Address</label>
              <input
                type="email"
                class="form-control"
                formControlName="address" />
              <lana-error-display
                [control]="formGroup.get('address')"
                label="Email Address"></lana-error-display>
            </div>
            <div class="form-group">
              <label>Receive Notifications</label>
              <div class="list-group list-group-horizontal switch">
                <li
                  (click)="formGroup.get('notificationsEnabled').setValue(true)"
                  class="list-group-item"
                  [class.active]="formGroup.get('notificationsEnabled').value">
                  Yes
                </li>
                <li
                  (click)="
                    formGroup.get('notificationsEnabled').setValue(false)
                  "
                  class="list-group-item"
                  [class.active]="!formGroup.get('notificationsEnabled').value">
                  No
                </li>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-start">
          <ng-template #defaultTemplate>
            <p>
              Are you sure you wish to delete
              <strong>{{ formGroup.value.address }}</strong
              >?
            </p>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="toggleConfirm()">
              No, Nevermind
            </button>
            <button
              type="button"
              class="btn btn-sm btn-success"
              (click)="deleteEmail(formGroup, modal)">
              Yes, Delete Email
            </button>
          </ng-template>
          <ng-container *ngIf="!showConfirm; else defaultTemplate">
            <button
              *ngIf="formGroup.value.id"
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="toggleConfirm()">
              Delete Email
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary ml-auto"
              (click)="confirmAddEmail(formGroup, modal)">
              {{ formGroup.value.id ? 'Update' : 'Add' }} Email
            </button>
          </ng-container>
        </div>
      </ng-template>
      <ng-container *ngIf="isCurrentUser | async as isCurrentUser">
        <ng-template #addEmailTemplate>
          <button
            (click)="openModal(emailContent)"
            type="button"
            class="btn btn-sm btn-primary">
            Add Email
          </button>
        </ng-template>
        <ng-template #defaultAddEmailTemplate>
          <ng-container
            *lanaHasRole="
              [roles.Administrator];
              then addEmailTemplate
            "></ng-container>
        </ng-template>
        <ng-container
          *ngIf="
            isCurrentUser;
            then addEmailTemplate;
            else defaultAddEmailTemplate
          "></ng-container>
      </ng-container>
    </div>
  </div>
  <ng-template #loadingTemplate>
    <lana-loading></lana-loading>
  </ng-template>
  <div class="card-body p-0">
    <ul class="list-group list-group-flush">
      <ng-template #detaultComment>
        <li class="list-group-item p-5 text-center">
          <p class="mb-0">No email addresses found</p>
        </li>
      </ng-template>
      <ng-container
        *ngIf="user && user.emailAddresses.length > 0; else detaultComment">
        <li
          class="list-group-item"
          *ngFor="let emailAddress of user.emailAddresses">
          <div class="d-flex align-items-center">
            <div class="mr-auto">
              {{ emailAddress.address }}
            </div>
            <div class="mr-2">
              <i
                [ngClass]="{
                  'fas fa-fw fa-bell': emailAddress.notificationsEnabled,
                  'far fa-fw fa-bell-slash': !emailAddress.notificationsEnabled
                }"></i>
            </div>
            <div class="small" *lanaHasRole="[roles.Administrator]">
              <a
                (click)="openModal(emailContent, formGroup, emailAddress)"
                href="javascript:void(0)"
                >Edit</a
              >
            </div>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
